import {cn, cva} from 'platform/shared';

import {ReactNode, UIEventHandler} from 'react';

interface ScrollWithoutScrollbarProps {
  $direction: 'x' | 'y';
  children?: ReactNode;
  onScroll?: UIEventHandler<HTMLDivElement>;
  tabIndex?: number;
}

const scrollWithoutScrollbarVariants = cva(
  '[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [&::-webkit-scrollbar]:size-0',
  {
    variants: {
      direction: {
        x: 'overflow-x-auto',
        y: 'overflow-y-auto',
      },
    },
  }
);

export function ScrollWithoutScrollbar(props: ScrollWithoutScrollbarProps) {
  return (
    <div
      className={cn(scrollWithoutScrollbarVariants({direction: props.$direction}))}
      onScroll={props.onScroll}
      tabIndex={props.tabIndex}
    >
      {props.children}
    </div>
  );
}
